import { forwardRef } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { IconModified } from 'src/assets/icons/Modified';
import { CustomIconButton } from 'src/components/CustomIconButton';
import { CustomTooltip } from 'src/components/CustomTooltip';
import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';
import { STRUCTURE_INSTRUCTIONS_LABEL } from 'src/data/ui';

import { useStyles } from './useStyles';

export const HeaderListItem = forwardRef(
  (
    {
      className,
      onSettingsClick,
      onSettingsPopupStateChange,
      isImageTool,
      hideTitle,
      hideSettingsButton,
      disabled,
    },
    ref
  ) => {
    const styles = useStyles();

    const handleMouseDown = (e) => {
      // Prevent default to stop focus loss
      e.preventDefault();
      e.stopPropagation();
      // Set the ref immediately on mousedown, before any focus loss
      if (onSettingsPopupStateChange) {
        onSettingsPopupStateChange(true);
      }
    };

    const handleSettingsClick = (e) => {
      e.stopPropagation();
      e.preventDefault();
      // Prevent the click from causing focus loss
      e.nativeEvent?.stopImmediatePropagation?.();
      onSettingsClick?.(e);
    };

    return (
      <div
        className={cx(styles.root, className)}
        ref={ref}
      >
        {!hideTitle && (
          <CustomTypography
            className={styles.title}
            variant={TYPOGRAPHY_VARIANT.medium14}
          >
            {isImageTool ? 'Improve image' : 'Prompt shortcuts'}
          </CustomTypography>
        )}

        {!isImageTool && !hideSettingsButton && (
          <CustomTooltip title={STRUCTURE_INSTRUCTIONS_LABEL}>
            <CustomIconButton
              className={styles.settingsButton}
              onMouseDown={handleMouseDown}
              onClick={handleSettingsClick}
              disabled={disabled}
            >
              <IconModified />
            </CustomIconButton>
          </CustomTooltip>
        )}
      </div>
    );
  }
);

HeaderListItem.propTypes = {
  className: PropTypes.string,
  onSettingsClick: PropTypes.func,
  onSettingsPopupStateChange: PropTypes.func,
  isImageTool: PropTypes.bool,
  hideTitle: PropTypes.bool,
  hideSettingsButton: PropTypes.bool,
  disabled: PropTypes.bool,
};
HeaderListItem.defaultProps = {
  className: '',
  onSettingsClick: null,
  onSettingsPopupStateChange: null,
  isImageTool: false,
  hideTitle: false,
  hideSettingsButton: false,
  disabled: false,
};
